export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="rounded-3xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20laptop%20showing%20product%20grid%20alongside%20neatly%20arranged%20fashion%20items%20in%20soft%20pastel%20colors%2C%20bright%20airy%20window%20light%2C%20minimal%20Scandinavian%20aesthetic%2C%20aspirational%20workspace%20photography%20with%20motivational%20atmosphere%20and%20warm%20neutral%20tones&width=1400&height=600&seq=cta-product-v2&orientation=landscape"
              alt="ACBuy Spreadsheet Products Collection"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            Start Your
            <br />
            <span className="font-heading italic font-normal text-foreground-500">ACBuy</span>{" "}
            Journey
            <br />
            <span className="font-heading italic font-bold">Today</span>
          </h2>

          <p className="mt-6 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Ready to level up your product sourcing? The acbuyspreadsheet platform connects you with
            thousands of verified products across every major category. Stop wasting hours on manual
            research and start using the most comprehensive acbuy spreadsheet resource available.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="bg-foreground-900 text-background-50 font-medium text-sm px-8 py-3.5 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              acbuy spreadsheet
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="bg-foreground-900 text-background-50 font-medium text-sm px-8 py-3.5 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              buy it now
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}